import { z } from 'zod';
import { ENABLED_VARIANT_FORMATS } from '../content/formats.js';
import { languageTagSchema } from '../language.js';
/**
 * `media_selector` (spec 80 §4.7, S80-5): picks assets for one variant out of
 * the candidates module 30 reports usable (ready photo with a social variant,
 * season match or `all_year`, people only when released, not over the reuse
 * limit). The model sees descriptions, tags and usage counts, never image data.
 */
/** Media count per format a selection must hit (spec 80 §4.7 validation; carousel 2-10, every other format 1). */
export const MEDIA_SELECTION_RANGE = {
    ig_feed: { min: 1, max: 1 },
    ig_carousel: { min: 2, max: 10 },
    ig_story: { min: 1, max: 1 },
    fb_feed: { min: 1, max: 1 },
    ig_reel: { min: 1, max: 1 },
    fb_reel: { min: 1, max: 1 },
    fb_story: { min: 1, max: 1 },
};
/** At most this many candidates go into one media-selector context. */
export const MEDIA_SELECTOR_MAX_CANDIDATES = 40;
export const mediaSelectorInputSchema = z
    .object({
    content_item_id: z.uuid(),
    variant_id: z.uuid(),
    base_version_id: z.uuid(),
})
    .strict();
export const mediaSelectorOutputSchema = z
    .object({
    selections: z
        .array(z
        .object({
        asset_id: z.string().min(1).max(64),
        position: z.number().int().min(0).max(9),
        reason: z.string().min(1).max(300),
    })
        .strict())
        .min(1)
        .max(10),
})
    .strict();
/** `POST /v1/ai/preparations` (spec 80 §4.8): formats to create, target languages to translate into. */
export const AI_PREPARATION_LIMITS = { maxFormats: ENABLED_VARIANT_FORMATS.length, maxLanguages: 5 };
/**
 * Formats a given photo can fill on its own (S160-2): exactly one photo per
 * variant. A preparation with `photo_asset_id` accepts only these.
 */
export const PHOTO_POST_FORMATS = ['ig_feed', 'fb_feed', 'ig_story'];
export const aiPreparationRequestSchema = z
    .object({
    content_item_id: z.uuid(),
    formats: z.array(z.enum(ENABLED_VARIANT_FORMATS)).min(1).max(AI_PREPARATION_LIMITS.maxFormats),
    languages: z.array(languageTagSchema).max(AI_PREPARATION_LIMITS.maxLanguages),
    /** S160-2: the member's own photo for every variant; the chain then writes about it and selects no media. */
    photo_asset_id: z.uuid().optional(),
})
    .strict();
//# sourceMappingURL=media-selector.js.map